import routers, {buildPath} from '@/config/routers';
import {DocRole} from '@/Constant';
import {isBoolean} from 'lodash-es';

export const permissionType = {
    Member: 'W',
    Reader: 'R',
};

export function getIsDisable(powerValue: string, value: string) {
    if (powerValue === DocRole.Member) {
        return value !== permissionType.Member;
    }
    return value !== permissionType.Reader && value !== permissionType.Member;
}

export function filterNode(item: any, level:number, powerValue:string, data: any) {
    const url = buildPath(routers.Knowledge.docPath, {
        spaceGuid: item.spaceGuid || '',
        groupGuid: item.groupGuid || '',
        repositoryGuid: item.repositoryGuid || '',
        docGuid: item.docGuid || '',
    });
    Object.assign(item, {
        id: item.docGuid,
        key: item.docGuid,
        isLeaf: !item?.children.length,
        text: item.name,
        url,
        level,
        spaceGuid: data.spaceGuid,
        groupGuid: data.groupGuid,
        checked: isBoolean(item.checked) ? item.checked : true,
        disabled: getIsDisable(powerValue, item.perm),
    });
    return item;
}

export function getBookTreeNodeList(result: any[], level: number, powerValue:string, data: {
    spaceGuid: string;
    groupGuid: string;
}) {
    result.forEach(item => {
        filterNode(item, level, powerValue, data);
        if (item.children && Array.isArray(item.children)) {
            getBookTreeNodeList(item.children, level + 1, powerValue, data);
        }
    });
}

export function getBookTreeData(treeData: any, parentKey: any, children: any) {
    const loop = (data: any) => {
        for (const item of data) {
            if (item.key === parentKey) {
                // eslint-disable-next-line no-param-reassign
                item.children = children;
                break;
            }
            if (item.children) {
                loop(item.children);
            }
        }
    };
    loop(treeData);
}

// 递归函数提取所有的 docGuids
export function extractDocGuids(arr: any[]) {
    let docGuids: any = [];

    arr && arr.forEach(item => {
        if (item.docGuid && item.children && Array.isArray(item.children)) {
            docGuids.push(item.docGuid);
        }
        if (item.children && Array.isArray(item.children)) {
            docGuids = docGuids.concat(extractDocGuids(item.children));
        }
    });

    return docGuids;
}

// 递归函数提取选中的文档列表
export function getCheckDocGuids(arr: any[]) {
    let docGuids: any = [];
    arr && arr.forEach(item => {
        if (item.docGuid && item.children && Array.isArray(item.children) && item.checked && !item.disabled) {
            docGuids.push(item.docGuid);
        }
        if (item.children && Array.isArray(item.children)) {
            docGuids = docGuids.concat(getCheckDocGuids(item.children));
        }
    });
    return docGuids;
}

// 递归函数查找并更新选中状态
export function updateByDocGuid(arr: any[], targetDocGuid: string, newChecked: boolean) {
    arr.forEach(item => {
        if (item.docGuid === targetDocGuid) {
            item.checked = newChecked;
            return true;
        }
        if (item.children && Array.isArray(item.children)) {
            const found = updateByDocGuid(item.children, targetDocGuid, newChecked);
            if (found) {
                return true;
            }
        }
    });
    return false;
}

// 递归函数查找获取选中的文档数量
export function getByIsCheckedNum(arr: any[]) {
    let docSelectNum: number = 0;
    let docDisabledNum: number = 0;

    arr.forEach(item => {
        if (item.docGuid && item.checked && !item.disabled) {
            docSelectNum += 1;
        }
        if (item.docGuid && item.disabled) {
            docDisabledNum += 1;
        }
        if (item.children && Array.isArray(item.children)) {
            docSelectNum = docSelectNum + getByIsCheckedNum(item.children).docSelectNum;
            docDisabledNum = docDisabledNum + getByIsCheckedNum(item.children).docDisabledNum;
        }
    });

    return {
        docSelectNum,
        docDisabledNum,
    };
}

